<template>
  <ItemDialog ref="DialogPurchaseWarning" imageType="loader">
    <template v-slot:content-area>
      <p class="text-left">
        <br />
        決済手続き中はこの画面を操作しないでください。決済が正しく行われない可能性があります。
        <br />
        決済を中止する場合は起動した決済画面を閉じてからアプリを操作してください。
      </p>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="OK"
        actionType="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogPurchaseWarning",
  setup() {
    const DialogPurchaseWarning = ref(null);

    const openDialog = () => {
      DialogPurchaseWarning.value.open();
    };

    const closeDialog = () => {
      DialogPurchaseWarning.value.close();
    };

    return {
      DialogPurchaseWarning,
      openDialog,
      closeDialog,
    };
  },
};
</script>

<style scoped lang="scss">
.text-left {
  text-align: justify;
}
</style>

